import { useEffect, useState } from "react";

export default function BoardFundraisingTestimonialsEditor({ client }) {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  useEffect(() => { client.get("/admin/board-fundraising/testimonial-library").then(r => setRows(r.data.testimonials)).catch(() => setError("Testimonials could not be loaded.")); }, [client]);
  const change = (index, field, value) => setRows(current => current.map((row, i) => i === index ? { ...row, [field]: value } : row));
  const move = (index, delta) => setRows(current => {
    const result = [...current]; [result[index], result[index + delta]] = [result[index + delta], result[index]]; return result;
  });
  const save = async e => {
    e.preventDefault(); setBusy(true); setError(""); setMessage("");
    try { await client.put("/admin/board-fundraising/testimonial-library", { testimonials: rows }); setMessage("Approved testimonial library and sequence saved."); }
    catch (err) { setError(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Testimonials could not be saved."); }
    finally { setBusy(false); }
  };
  return <form className="bf-admin-event-form" onSubmit={save}>
    <h3>Approved testimonials and sequence</h3>
    <p>Only approved records appear on the event sales page and in the email sequence. Already sent testimonials are not sent again when you change their order.</p>
    {rows.map((row, index) => <fieldset key={row.testimonial_id} className="bf-admin-event-card">
      <legend>{index + 1}. {row.name}</legend>
      <label>Name<input required value={row.name} onChange={e => change(index, "name", e.target.value)}/></label>
      <label>Organisation<input value={row.organization} onChange={e => change(index, "organization", e.target.value)}/></label>
      <label>Approved testimonial text<textarea required rows={5} value={row.quote} onChange={e => change(index, "quote", e.target.value)}/></label>
      <label>Days before the next testimonial<input type="number" min={1} max={365} value={row.delay_days} onChange={e => change(index, "delay_days", Number(e.target.value))}/></label>
      <label><input type="checkbox" checked={row.approved} onChange={e => change(index, "approved", e.target.checked)}/> Approved for publication and sending</label>
      <button type="button" disabled={index === 0} onClick={() => move(index, -1)}>Move earlier</button>{" "}
      <button type="button" disabled={index === rows.length - 1} onClick={() => move(index, 1)}>Move later</button>
    </fieldset>)}
    {error && <p role="alert">{error}</p>}{message && <p role="status">{message}</p>}
    <button className="button" disabled={busy || !rows.length}>Save approved testimonials and sequence</button>
  </form>;
}
